import { http, ep } from '../../client/http';

export const certificateRepo = {
  get: async () => {
    const res = await http.get(ep('certificate/list?limit=100'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
